import { ConfirmationType } from '../model/types';

const CONFIRMATION_TYPE_PRIORITY: readonly ConfirmationType[] = [
  ConfirmationType.Quick,
  ConfirmationType.Long,
  ConfirmationType.Cancel,
];

export function getProductsConfirmationType(
  products: readonly { confirmationType: ConfirmationType | null }[],
): ConfirmationType | null {
  const types = new Set(products.map((product) => product.confirmationType));

  return CONFIRMATION_TYPE_PRIORITY.find((type) => types.has(type)) ?? null;
}
